import React from 'react';

import constants from 'client/constants';

import {Anchor, Dialogue, Button, Text} from '@albert-io/atomic';

interface Props {
  className: string;
  handleClose: () => void;
}

const GenericLmsError = ({className, handleClose}: Props) => (
  <Dialogue
    hideCloseBtn
    className={className}
    size='m'
    title='We could not access your roster information.'
  >
    <Dialogue.Body>
      <div className='u-display_flex u-flex-direction_column'>
        <Text>We could not import your roster at this time.</Text>
        <Text>
          If the error persists, contact our support team through the chat widget below or by{' '}
          <Anchor href={`mailto:${constants.CONTACT.EMAIL.SUCCESS}`} inheritColor underlined>
            email
          </Anchor>
          .
        </Text>
      </div>
    </Dialogue.Body>
    <Dialogue.BtnGroup>
      <Button onClick={() => handleClose()}>Dismiss</Button>
    </Dialogue.BtnGroup>
  </Dialogue>
);

export default GenericLmsError;
